import axiosInstance from "./AxiosInstance"

export function getReminderList() {
  return axiosInstance.post("/servicecaller/reminderList")
}

export function updateReminder(reminderData) {
  return axiosInstance.post("/servicecaller/updateReminder", reminderData)
}
